import { combineReducers } from 'redux'

import creation from './creation'
import current from './current'

export default combineReducers({
  creation,
  current,
})



// WEBPACK FOOTER //
// ./src/stores/icons/index.js